export default {
  创建新标准库: '创建新标准库',
  跳转绘图列表: '跳转绘图列表',
  跳转类别管理: '跳转类别管理',
  跳转实体管理: '跳转实体管理',
  缩略图: '缩略图',
  代码: '代码',
  名称: '名称',
  版本: '版本',
  状态: '状态',
  备注: '备注',
  工作中: '工作中',
  已审批: '已审批',
  新增标准: '新增标准',
  修改标准: '修改标准',
  英文名称: '英文名称',
  中文名称: '中文名称',
  参考数据: '参考数据',
  来源系统: '来源系统',
  来源数据表: '来源数据表',
  来源数据字段: '来源数据字段',
  来源PK: '来源PK',
  类别: '类别',
  上级: '上级',
  新增规则: '新增规则',
  编辑规则: '编辑规则',
  规则类型: '规则类型',
  请填写规则正则: '请填写规则正则',
  请填写规则内容: '请填写规则内容',
  您尚有未保存的数据是否取消: '您尚有未保存的数据，是否取消?',
  提示: '提示',
  是: '是',
  否: '是',
  添加到任务: '添加到任务',
  数据源描述: '数据源描述',
  数据源类型: '数据源类型',
  数据源编码: '数据源编码',
  数据源名称: '数据源名称',
  创建人: '创建人',
  数据源模型: '数据源模型',
  外部数据源: '外部数据源',
  外部数据源连接: '外部数据源连接',
  测试连接: '测试连接',
  任务名称: '任务名称',
  运行状态: '运行状态',
  开始日期: '开始日期',
  结束日期: '结束日期',
  创建人姓名: '创建人姓名',
  序号: '序号',
  执行频次: '执行频次',
  上次运行时间: '上次运行时间',
  上次运行状态: '上次运行状态',
  上次运行耗时秒: '上次运行耗时(秒)',
  下次运行时间: '下次运行时间',
  总运行次数: '总运行次数',
  失败次数: '失败次数',
  任务创建人: '任务创建人',
  最近修改人: '最近修改人',
  修改时间: '修改时间',
  请输入任务名称: '请输入任务名称',
  质检源: '质检源',
  执行频度: '执行频度',
  任务状态: '任务状态',
  请选择任务状态: '请选择任务状态',
  是否重试: '是否重试',
  重试次数: '重试次数',
  请输入次数: '请输入次数',
  间隔时间: '间隔时间(秒)',
  请输入间隔时间: '请输入间隔时间',
  失败原因: '失败原因',
  关联表: '关联表',
  请选择业务主题域: '请选择业务主题域',
  请输入表名或中文名称: '请输入表名或中文名称',
  表名: '表名',
  实体中文名称: '实体中文名称',
  实体说明: '实体说明',
  规则: '规则',
  请输入属性中文名称: '请输入属性中文名称',
  属性英文名称: '属性英文名称',
  属性中文名称: '属性中文名称',
  消息设置: '消息设置',
  规则问题情况: '规则问题情况',
  规则描述或规则类型: '规则描述或规则类型',
  报告: '报告',
  规则内容: '规则内容',
  规则描述: '规则描述',
  检查数: '检查数',
  问题数: '问题数',
  问题比例: '问题比例',
  影响类库: '影响类库',
  字段明细情况: '字段明细情况',
  搜索类别代码或类别名称: '搜索类别代码或类别名称',
  问题总数: '问题总数',
  详情: '详情',
  后退: '后退',
  通知设置: '通知设置',
  请选择通知设置: '请选择通知设置',
  通知方式: '通知方式',
  请选择通知方式: '请选择通知方式',
  通知标题: '通知标题',
  请输入标题: '请输入标题',
  通知接收人: '通知接收人',
  多个人以逗号分隔: '多个人以逗号分隔',
  通知描述: '通知描述',
  请输入描述内容: '请输入描述内容',
  发送日志: '发送日志',
  整改状态: '整改状态',
  数据表: '数据表',
  稽核数据量: '稽核数据量',
  异常数据量: '异常数据量',
  整改: '整改',
  整改记录: '整改记录',
  整改时间: '整改时间',
  整改项: '整改项',
  第几行: '第几行',
  整改前: '整改前',
  整改后: '整改后',
  异常描述: '异常描述',
  整改人: '整改人',
  操作人: '操作人',
  操作时间: '操作时间',
  返回: '返回',
  提交审核: '提交审核',
  审批批次号: '审批批次号',
  审批数据表: '审批数据表',
  审批状态: '审批状态',
  审批意见: '审批意见',
  操作者: '操作者',
  数据审批设置: '数据审批设置',
  数据审批编辑: '数据审批编辑',
  请选择数据标准库: '请选择数据标准库',
  数据标准库: '数据标准库',
  操作: '操作',
  审批人: '审批人',
  请选择数据表: '请选择数据表',
  请填写审批意见: '请填写审批意见',
  审批通过: '审批通过',
  审批驳回: '审批驳回',
  查看文件: '查看文件',
  请选择主题: '请选择主题',
  请选择属性: '请选择属性',
  请选择操作符: '请选择操作符',
  请输入关键字: '请输入关键字',
  资产: '资产',
  基本信息: '基本信息',
  实体: '实体',
  归类属性: '归类属性',
  实体集名称: '实体集名称',
  归类实体属性: '归类实体属性',
  归类实体属性值: '归类实体属性值',
  引用实体列表: '引用实体列表',
  启用: '启用',
  停用: '停用',
  编码: '编码',
  资产数据维度编码: '资产数据维度编码',
  资产数据维度名称: '资产数据维度名称',
  标准: '标准',
  描述: '描述',
  资产数据维度描述: '资产数据维度描述',
  限定数据标签: '限定数据标签',
  数据标签: '数据标签',
  限定实体归集: '限定实体归集',
  实体归集: '实体归集',
  展开属性: '展开属性',
  引用实体: '引用实体',
  显示属性: '显示属性',
  是否递归展示: '是否递归展示',
  层级: '层级',
  描述文字: '描述文字',
  请输入主题名称: '请输入主题名称',
  请输入实体名称或实体编码: '请输入实体名称或实体编码',
  实体代码: '实体代码',
  实体名称: '实体名称',
  搜索代码: '搜索代码',
  搜索名称: '搜索名称',
  打开方式: '打开方式',
  操作类别: '操作类别',
  响应者: '响应者',
  参数: '参数',
  新增业务操作: '新增业务操作',
  编辑业务操作: '编辑业务操作',
  查看业务操作: '查看业务操作',
  参数名: '参数名',
  属性: '属性',
  业务操作: '业务操作',
  呈现方式: '呈现方式',
  参数属性: '参数属性',
  按钮名或提示: '按钮名或提示',
  测点编码或测点名称: '测点编码或测点名称',
  单位: '单位',
  测点周期: '测点周期(ms)',
  测点类型: '测点类型',
  测点驱动: '测点驱动',
  测点编码: '测点编码',
  测点名称: '测点名称',
  请填写测点编码: '请填写测点编码',
  请填写测点名称: '请填写测点名称',
  请填写单位: '请填写单位',
  请填写测点周期: '请填写测点周期',
  请填写表达式: '请填写表达式',
  请填写量程上限: '请填写量程上限',
  请填写量程下限: '请填写量程下限',
  请填写测点序号: '请填写测点序号',
  请选择专业: '请选择专业',
  请选择机组: '请选择机组',
  量程上限: '量程上限',
  量程下限: '量程下限',
  实时数据查询: '实时数据查询',
  历史数据查询: '历史数据查询',
  颗粒度: '颗粒度',
  趋势曲线: '趋势曲线',
  测点: '测点',
  机组: '机组',
  实时值: '实时值',
  时间: '时间',
  数值: '数值',
  名称描述: '名称/描述',
  类型: '类型',
  支撑应用数: '支撑应用数',
  调用次数: '调用次数',
  API定义: 'API定义',
  API验证: 'API验证',
  API名称: 'API名称',
  API代码: 'API代码',
  地址: '地址',
  调用建议: '调用建议',
  使用场景: '使用场景',
  API类型: 'API类型',
  请求方式: '请求方式',
  引用属性: '引用属性',
  属性别名: '属性别名',
  查询方式: '查询方式',
  请求字段: '请求字段',
  返回字段: '返回字段',
  请以openapi开头: '请以/openapi/开头',
  请输入API名称: '请输入API名称',
  请输入API代码: '请输入API代码',
  API简要描述: 'API简要描述',
  API调用建议: 'API调用建议',
  API使用场景说明: 'API使用场景说明',
  验证: '验证',
  表格: '表格',
  API格式: 'API格式',
  申请应用: '申请应用',
  申请部门: '申请部门',
  是否启用: '是否启用',
  请选择状态: '请选择状态',
  申请人: '申请人',
  申请描述: '申请描述',
  API接口: 'API接口',
  目标系统: '目标系统',
  目标表: '目标表',
  目标表中文名: '目标表中文名',
  更新时间: '更新时间',
  更新状态: '更新状态',
  apsql语句: 'ap/sql语句',
  字段映射: '字段映射',
  目标字段: '目标字段',
  源系统: '源系统',
  源数据库: '源数据库',
  源字段: '源字段',
  目标字段中文名: '目标字段中文名',
  采集来源: '采集来源',
  源数据库表名: '源数据库表名',
  源字段中文名: '源字段中文名',
  请选择审批人: '请选择审批人',
  新增: '新增',
  编辑: '编辑',
  对象编码: '对象编码',
  对象名称: '对象名称',
  信息类别: '信息类别',
  confirmContinueIgnoreIsExist: '系统中存在同名字典，是否继续',
  codeOrName: '代码或名称',
}
